import { AuthService } from './../../services/auth.service';
import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-user-bar',
  templateUrl: './user-bar.component.html',
  styleUrls: ['./user-bar.component.css']
})
export class UserBarComponent implements OnInit {

  email: string = '';
  constructor(private authService: AuthService) {
    this.email = this.authService.currentUser.sub;
  }

  ngOnInit(): void {
  }

  get isLoggedIn() {
    return this.authService.isLoggedIn();
  }

  isInRole(role: string) {
    return this.authService.isInRole(role);
  }

  logout() {
    this.authService.logout();
  }
}
